import {useEffect, useRef, useState} from "react";
import {Dropdown} from 'react-bootstrap';
import InstrumentIcon from "../../../../components/instrument-icon";
import SvgIcon from "../../../../components/svg-icon";
import {useTranslation} from "react-i18next";


const fromCurrencies = [
    // {code: "TRY", label: "Türk lirası"},
    {code: "USD", label: "United States dollar"},
    {code: "EUR", label: "Euro"},
    // {code: "DKK", label: "Dansk krone"},
    // {code: "BND", label: "Ringgit Brunei"},
    // {code: "IDR", label: "Rupiah"},
    // {code: "MYR", label: "Ringgit"},
    // {code: "PHP", label: "Piso ng Pilipinas"},
    // {code: "TWD", label: "新臺幣"},
    // {code: "VND", label: "đồng"},
    // {code: "ARS", label: "Peso argentino"},
    // {code: "BOB", label: "Boliviano"},
    // {code: "BRL", label: "Real brasileiro"},
    // {code: "CLP", label: "Peso chileno"},
    // {code: "COP", label: "Peso colombiano"},
    // {code: "CRC", label: "Colón costarricense"},
    // {code: "DOP", label: "Peso dominicano"},
    // {code: "SVC", label: "Colón salvadoreño"},
    // {code: "GTQ", label: "Quetzal guatemalteco"},
    // {code: "HNL", label: "Lempira hondureño"},
    // {code: "BZD", label: "Belize dollar"},
    // {code: "MXN", label: "Peso mexicano"},
    // {code: "PAB", label: "Balboa panameño"},
    // {code: "PEN", label: "Sol peruano"},
    // {code: "UYU", label: "Peso uruguayo"},
    // {code: "PYG", label: "Guaraní paraguayo"},
    // {code: "DZD", label: "دينار جزائري"},
    // {code: "AOA", label: "Kwanza angolano"},
    // {code: "BHD", label: "دينار بحريني"},
    // {code: "CVE", label: "Escudo cabo-verdiano"},
    // {code: "BWP", label: "Pula ya Botswana"},
    // {code: "BIF", label: "Franc burundais"},
    // {code: "XAF", label: "Franc CFA"},
    // {code: "EGP", label: "جنيه مصري"},
    // {code: "KMF", label: "فرنك قمري"},
    // {code: "ERN", label: "ናቕፋ"},
    // {code: "GMD", label: "Dalasi"},
    // {code: "GEL", label: "ლარი"},
    // {code: "GHS", label: "Ghana cedi"},
    // {code: "GIP", label: "Gibraltar pound"},
    // {code: "IRR", label: "ریال ایران"},
    // {code: "ILS", label: "שקל ישראלי חדש"},
    // {code: "JOD", label: "دينار أردني"},
    // {code: "KES", label: "Shilingi ya Kenya"},
    // {code: "KWD", label: "دينار كويتي"},
    // {code: "LSL", label: "Loti"},
    // {code: "LRD", label: "Liberian dollar"},
    // {code: "MGA", label: "Ariary malgache"},
    // {code: "MWK", label: "Kwacha wa Malawi"},
    // {code: "MRU", label: "أوقية موريتانية"},
    // {code: "MDL", label: "Leu moldovenesc"},
    // {code: "MAD", label: "درهم مغربي"},
    // {code: "MZN", label: "Metical moçambicano"},
    // {code: "NAD", label: "Namibian dollar"},
    // {code: "XOF", label: "Franc CFA d'Afrique de l'Ouest"},
    // {code: "NGN", label: "Naira"},
    // {code: "OMR", label: "ريال عماني"},
    // {code: "QAR", label: "ريال قطري"},
    // {code: "RWF", label: "Franc rwandais"},
    // {code: "STN", label: "Dobra de São Tomé e Príncipe"},
    // {code: "SAR", label: "ريال سعودي"},
    // {code: "RSD", label: "Српски динар"},
    // {code: "ZAR", label: "Rand"},
    // {code: "TZS", label: "Shilingi ya Tanzania"},
    // {code: "TND", label: "دينار تونسي"},
    // {code: "UAH", label: "Гривня"},
    // {code: "AED", label: "درهم إماراتي"},
    // {code: "ZMW", label: "Kwacha"}
];

const FromCurrenciesDropdown = ({selectedCurrency, handleChangeWallet}) => {
    const {t} = useTranslation()

    const [show, setShow] = useState(false);
    const dropdownRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');


    // Handle click outside dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShow(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Dropdown
            className="modal__wallet-dropdown width-unset flex-column"
            show={show}
            onToggle={setShow}
            ref={dropdownRef}
        >
            <span className="text-secondary">{t('buy-crypto.from-currency','From Currency')}</span>
            <Dropdown.Toggle
                className="modal__wallet-dropdown-btn"
                id="modalWallet1"
                aria-expanded={show}
                onClick={() => setShow(!show)}
                // disabled={true}
            >
                <div className="d-flex gap-2 align-items-center">
                    <InstrumentIcon code={selectedCurrency?.code}/>
                    {selectedCurrency?.code}
                </div>

                <SvgIcon id={'right-down'}/>
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-menu modal__wallet-menu" aria-labelledby="modalWallet1">
                <div className="modal__wallet-search">
                    <input
                        type="text"
                        name="search"
                        className="search__input"
                        placeholder="Search currencies"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <ul className="modal__wallet-currencies">
                    {
                        fromCurrencies
                            .map((wallet) => (
                                <li
                                    key={wallet?.code}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        handleChangeWallet(wallet);
                                        setShow(false); // Close dropdown after selecting
                                    }}
                                >
                                <span>
                                  <InstrumentIcon code={wallet?.code}/>
                                    {wallet?.code} <span className="text-secondary">({wallet.label})</span>
                                </span>
                                </li>
                            ))}
                </ul>
            </Dropdown.Menu>
        </Dropdown>
    )

}


export default FromCurrenciesDropdown
